<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="warea">
                    <div class="col-12 mt-2">
                        <div class="row mr-0" id="lfprd">
                            <div class="col-12 m-record">
                                <div class="row nav-top auto">
                                    <div class="col-12 ddavc"><span class="nav-back wt"  @click="$router.go(-1)"></span><span
                                            class="tfw-5 tf-18" id="mxGRT">{{getser(server)}}</span><span
                                            class="pl-1 tfw-5 tf-18"> Record</span></div>
                                    <div class="col-12" id="mnvbt">
                                        <div class="row mr-0 tf-14">
                                            <div class="col-4 pa-0 xtl">Period</div>
                                            <div class="col-2">Price</div>
                                            <div class="col-2">Result</div>
                                            <div class="col-4 pa-0 xtr">Open Time</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12" id="dtaod" v-for="row in resultrec" :key="row.id">
                                        
                                        <div class="row mt-2 mb-2 lih-32">
                                            <div class="col-4 xtl">{{row.period}}</div>
                                            <div class="col-2">{{row.num}}</div>
                                            <div class="col-2">
                                                <div :class="getcolor(row.clo,row.ans)">
                                                    <div class="vil" v-show="row.res1 == 'violet'"></div>
                                                    <div :class="getcl(row.clo)">{{getans(row.ans)}}</div>
                                                </div>
                                            </div>
                                            <div class="col-4 xtr tfwr">{{gettime(row.time)}}</div>
                                        </div>
                                       
                            
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        <div class="row mr-0 mordm"></div>
                    </div>
                    <div class="col-12" id="ucheck"></div>
                    <div class="col-12" id="suc-fail"></div>
                    <div class="col-12" id="xrule"></div>
                </div>
                <div class="row" id="odrea"></div>
                <div class="row" id="footer"></div>
                <div class="row" id="opffp"></div>
                <div class="row" id="anof">
                </div>
                <div class="row" id="dta_ref"></div>
            </div>
        </div>
    </section>
</template>


<script>
import axios from "axios";
export default {
  name: "HomeView",
  data() {
    return {
      server: null,
      resultrec:[]
    }

  },
  beforeCreate: function () {
    if (localStorage.getItem('username') == null) {
      this.$router.push({ name: 'login' });
    }

  },
  created: function () {
        this.server = this.$route.query.server;
    },
  mounted: function () {
    this.getrec();
  },
  methods: {
    getrec() {
        axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=resultrecord&server=' + this.server).then((res) => {
                this.resultrec = res.data;
                console.log(this.resultrec);
            }).catch((err) => {
                console.log(err);
            })
    },
    gettime(time){
        var timeStamp=Date.parse(time);
        const date= new Date(timeStamp);
        var dateFormat =  date.getDate()+
           "/"+(date.getMonth()+1)+" "+date.getHours()+
           ":"+date.getMinutes()+":0"+date.getSeconds();
        return dateFormat;
    },
    getser(a){
if(a=="Wheelocity") {
    return "Circle" ;
}else{
    return a;
}
    },
    getans(a){
if(this.server=="Wheelocity") {
    return  ;
}else{
    return a;
}
    },
    getcl(a){
if(this.server=="Wheelocity") {
    return  'wlrcd wlb '+a;
}else{
    return "tpr";
}
    },
    getcolor(stat,res){
        if(this.server=="FastParity" || this.server=="Parity" || this.server=="Sapre"){
        if(stat=="red"){
           return 'RS';
        }else if(stat=="green"){
           return 'GS';
        }
        }else if(this.server=="AndharBahar"){
            if(res=='A'){
                return 'GS A';
            }else if(res=='B'){
                return 'RS B';
            }else if(res=='T'){
                return 'VS T';
            }
        }else{
            return 'NS';
        }
        
    }
  

  }
}
</script>
